<script setup lang="ts">
</script>

<template>
  <div
    class="animate-pulse bg-gray-600 rounded-md"
  />
</template>
